import React, { useEffect } from "react";
import ReactGA4 from "react-ga4";

import { shopId } from "config/const";
import { useAuth } from "providers/Auth";

import {
  GA_UTM_SOURCE,
  GA_UTM_MEDIUM,
  GA_UTM_CAMPAIGN,
  GA_UTM_TERM,
  GA_UTM_ID,
} from "config/const";

export default function WithTracker({ children, ga }) {
  const { auth } = useAuth();
  const lineId = auth.userId;

  useEffect(() => {
    if (!lineId || !ga) return;
    const page = `/shop/${shopId}/user/${lineId}/action/${ga}`;

    const pageviewEvent = {
      hitType: "pageview",
      page,
      userId: `shop/${shopId}/user/${lineId}`,
      referrer: `https://linebot/shop/${shopId}/user/${lineId}`,
      location: window.location.href || "",
      title: ga,
      campaignSource: localStorage.getItem(GA_UTM_SOURCE),
      campaignMedium: localStorage.getItem(GA_UTM_MEDIUM),
      campaignName: localStorage.getItem(GA_UTM_CAMPAIGN),
      campaignKeyword: localStorage.getItem(GA_UTM_TERM),
      campaignId: localStorage.getItem(GA_UTM_ID),
    };
    console.log("pageview", pageviewEvent);

    ReactGA4.send(pageviewEvent);
  }, [lineId, ga]);

  return <>{children}</>;
}
